var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoolAvailability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.667h-2v-1a.333.333 0 1 0-.667 0v1H4.666v-1a.333.333 0 0 0-.666 0v1H2A1.669 1.669 0 0 0 .333 3.334v8.667A1.669 1.669 0 0 0 2 13.667h10a1.668 1.668 0 0 0 1.666-1.666V3.334A1.668 1.668 0 0 0 12 1.667zm1 10.334a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6.334h12v5.667zm0-6.334H1V3.334a1 1 0 0 1 1-1h2v1a.333.333 0 0 0 .666 0v-1h4.667v1a.333.333 0 0 0 .667 0v-1h2a1 1 0 0 1 1 1v2.333z",
    fill: "#111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolAvailability);
export default __webpack_public_path__ + "static/media/pool-availability.b6b6147f4ca74a06be48757c70c70114.svg";
export { ForwardRef as ReactComponent };